module.exports = __webpack_public_path__ + "static/media/checkboxFilledNew.d863d4ba.svg";